var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0391 21.5827C23.2336 21.5827 22.5807 22.2356 22.5807 23.041V36.166C22.5807 36.9715 23.2336 37.6244 24.0391 37.6244H37.1641C37.9695 37.6244 38.6224 36.9715 38.6224 36.166V23.041C38.6224 22.2356 37.9695 21.5827 37.1641 21.5827H24.0391ZM19.6641 23.041C19.6641 20.6248 21.6228 18.666 24.0391 18.666H37.1641C39.5804 18.666 41.5391 20.6248 41.5391 23.041V36.166C41.5391 38.5823 39.5804 40.541 37.1641 40.541H24.0391C21.6228 40.541 19.6641 38.5823 19.6641 36.166V23.041Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.832 11.3747C13.4453 11.3747 13.0743 11.5283 12.8008 11.8018C12.5273 12.0753 12.3737 12.4462 12.3737 12.833V25.958C12.3737 26.3448 12.5273 26.7158 12.8008 26.9892C13.0743 27.2626 13.4453 27.4163 13.832 27.4163H15.2904C16.0958 27.4163 16.7487 28.0692 16.7487 28.8747C16.7487 29.6801 16.0958 30.333 15.2904 30.333H13.832C12.6717 30.333 11.5589 29.872 10.7384 29.0516C9.91797 28.2311 9.45703 27.1183 9.45703 25.958V12.833C9.45703 11.6727 9.91797 10.5599 10.7384 9.73942C11.5589 8.91894 12.6717 8.45801 13.832 8.45801H26.957C28.1173 8.45801 29.2301 8.91894 30.0506 9.73942C30.8711 10.5599 31.332 11.6727 31.332 12.833V14.2913C31.332 15.0967 30.6791 15.7497 29.8737 15.7497C29.0683 15.7497 28.4154 15.0967 28.4154 14.2913V12.833C28.4154 12.4462 28.2617 12.0753 27.9882 11.8018C27.7148 11.5283 27.3438 11.3747 26.957 11.3747H13.832Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.4db2669c52801aa9d6eddd1f642a514c.svg";
export { ForwardRef as ReactComponent };